import About from "./components/About";
import Contact from "./components/Contact";
import GoToTop from "./components/GoToTop";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Project from "./components/Project";
import SocialLinks from "./components/SocialLinks";
import Statistics from "./components/Statistics";
import Tools from "./components/Tools";

function App() {
  return (
    <div>
      <Navbar/>
      <Home/>
      <About/>
      <Statistics/>
      <Tools/>
      <Project/>
      <Contact/>
      <Footer/>
      <SocialLinks/>
      <GoToTop/> 
    </div>
  );
}

export default App;
